import { TrainingPackage } from '../../models/training/training-package.model';

export enum ActionTypes {
  RememberTrainingPackage = '[RememberTrainingPackage] action',
  ResetTrainingPackage = '[ResetTrainingPackage] action'
}

export class RememberTrainingPackage {
  public static readonly type = ActionTypes.RememberTrainingPackage;
  constructor(public payload: TrainingPackage, public isLoadedSuccessfully: boolean) { }
}

export class ResetTrainingPackage {
  public static readonly type = ActionTypes.ResetTrainingPackage;
  constructor() { }
}
